import { Step } from 'walktour'

export type ProductTourData = {
  ctaLink?: string
  imageSrc?: string
}

export type Tour = 'home' | 'designer' | 'content_calendar' | 'social_media_doc' | 'blog_post_output'

export type CompletedTours = Partial<{
  [K in Tour]: boolean
}>

export type TourProps = {
  // Filters steps for dynamic tours
  stepFilter?: (steps: Step[]) => Step[]

  // Can contextually decide if tour should be shown
  eligible?: boolean

  // Runs before starting the tour to ensure tour will run correctly in context
  beforeStart?: () => void | Promise<void>
}

export type TourStartCard = {
  title: string
  content: string
}

export const TOUR_NAMES: Record<Tour, string> = {
  home: 'Home Tour',
  designer: 'Designer Tour',
  blog_post_output: 'Blog Post Tour',
  social_media_doc: 'Social Media Tour',
  content_calendar: 'Content Calendar Tour',
}
